export default function getServicesAvailable() {
  const services_available = [
    { label: "Document Analysis", value: true },
    { label: "Technical/Physical Verification", value: true },
    { label: "Document Writing", value: true },
    { label: "Price Analysis", value: true },
    { label: "Client Profiling", value: true },
    { label: "Bridge Financing", value: true },
    { label: "Mortgage Financing", value: true },
    { label: "Unsecured Lending", value: true },
    { label: "Identification of Property", value: true },
    { label: "Acquiring of Property", value: true },
    { label: "Disposal of Property", value: true },
    { label: "Wealth Management", value: true },
  ];
  return services_available;
}
